export function parseSeedUnits(rawUnits: string | null | undefined): string[] {
  if (!rawUnits) {
    return [];
  }

  try {
    const parsed: unknown = JSON.parse(rawUnits);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter((unit): unit is string => typeof unit === "string");
  } catch {
    return [];
  }
}
